import { useState } from 'react';
import Icono from 'design/assets/img/cta/icons/icon-contacts.svg';
import NeoTitleSecond from 'design/design_components/neo/title/NeoTitleSecond.base';
import NeoGridContainer from 'design/design_components/neo/layout/NeoGridContainer.base';
import NeoButtonSection from 'design/design_components/neo/layout/NeoButtonSection.base';
import NeoButtonMain from 'design/design_components/neo/button/NeoButtonMain.base';
import ContactsService from 'services/contacts.service';
import useMessages from 'hooks/useMessages.hook';
import LoadingDialog from 'components/LoadingDialog.component';
import TOAST from 'consts/toast.consts';

export default function ContactDetailHeader(props) {
  const messages = useMessages();
  const [downloadMessagesButtonClickDisabled, setDownloadMessagesButtonClickDisabled] = useState(false);
  const [loadingDialogText, setLoadingDialogText] = useState('');
  const [loadingDialogProgress, setLoadingDialogProgress] = useState(0);
  const [showDownloadingDialog, setShowDownloadingDialog] = useState(false);

  const handleDownloadMessagesButtonClick = async () => {
    setShowDownloadingDialog(true);
    setLoadingDialogText('Iniciando proceso...');
    setLoadingDialogProgress(0);
    setDownloadMessagesButtonClickDisabled(true);
    const { whatsAppId } = props.contact;
    const response = await ContactsService.getConversationMessagesFile(whatsAppId).finally(() => {
      setShowDownloadingDialog(false);
      setDownloadMessagesButtonClickDisabled(false);
    });
    if(response.success) {
      const downloadInstance = document.createElement('a');
      downloadInstance.href = response.payload.urlDownload;
      downloadInstance.target = '_blank';
      downloadInstance.click();
      messages.showToast(TOAST.SEVERITY.SUCCESS, 'Operación exitosa', 'Se descargó el reporte de mensajes.');
    }
    else {
      messages.showToast(TOAST.SEVERITY.ERROR, 'Algo salió mal', 'No se pudo descargar el reporte de mensajes, inténtalo de nuevo.');
    }
  }

  return (<>
    <NeoGridContainer>
      <NeoTitleSecond
        icon={Icono}
        title={props.contact.name ?? `~ ${props.contact.alias}`}
        subtitle='Detalle de contacto'
      />
      <NeoButtonSection align='right' col='12' md='6'>
        <NeoButtonMain
          icon="pi pi-download" 
          label='Reporte de mensajes' 
          onClick={handleDownloadMessagesButtonClick}
          disabled={downloadMessagesButtonClickDisabled}
        />
      </NeoButtonSection>
    </NeoGridContainer>
      {
        <LoadingDialog
          visible={showDownloadingDialog}
          message={loadingDialogText}
          progress={loadingDialogProgress}
          showValue={false}
        />
      }
  </>);
}